module.exports = __webpack_public_path__ + "static/media/picture-(230).41055d7d.JPG";